import { ManageRolesTableProperties } from "PFApp/activities/manage_roles/parts/table_properties/manage_roles_table_properties";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "../manage_roles_page.module.scss";

type ToolbarProps = {
  totalRoles: number;
};

export const Toolbar = ({ totalRoles }: ToolbarProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });

  return (
    <Inline className={css.toolbar} gap="spacingLg" alignItems="center" spread>
      <Typography variant="bodyRegular">{t("rolesCount", { count: totalRoles })}</Typography>
      <ManageRolesTableProperties />
    </Inline>
  );
};
